import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import safeproLogo from '../assets/safepro-logo.svg';
import { useTranslation } from 'react-i18next';

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch {
      setError(t('forgot.failed'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-sm w-full">
        <div className="text-center mb-8">
          <img src={safeproLogo} alt="Safe Digi" className="h-12 mx-auto mb-4" />
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <h1 className="text-base font-semibold text-gray-900 mb-1">{t('forgot.title')}</h1>
          <p className="text-sm text-gray-500 mb-4">
            {t('forgot.description')}
          </p>

          {sent ? (
            <div className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-lg px-3 py-3">
              {t('forgot.success')}
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">{t('forgot.email')}</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="w-full rounded-lg border-gray-300 text-sm focus:ring-brand-600 focus:border-brand-600"
                  placeholder={t('common.emailPlaceholder')}
                />
              </div>
              {error && (
                <div className="bg-red-50 border border-red-200 rounded-lg px-3 py-2 text-sm text-red-700">
                  {error}
                </div>
              )}
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-brand-700 hover:bg-brand-900 text-white font-medium py-2.5 rounded-lg text-sm transition-colors disabled:opacity-60"
              >
                {loading ? t('forgot.sending') : t('forgot.submit')}
              </button>
            </form>
          )}

          <div className="mt-4 text-center">
            <Link to="/kirjaudu" className="text-sm text-brand-700 hover:underline">
              ← {t('forgot.backToLogin')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
